import React, { useEffect, useState } from 'react'
import { Header } from '../../../components/header/Header'
import { useFormik } from 'formik';
import { CiImageOn } from "react-icons/ci";
import editIcon from "../../../assets/edit_icon.png";
import { ArtistValidationSchema } from './ArtistValidationSchema';
import { useDispatch, useSelector } from 'react-redux';
import { signupUserThunk as onSignUpUser } from "../../../slices/users/thunk";
import { createSelector } from '@reduxjs/toolkit';
import { Spinner } from '../../../components/spinner/Spinner';
import toast from 'react-hot-toast';

export default function CreateArtist() {

  const [preview, setPreview] = useState(null);
  const [isShowSpinner, setIsShowSpinner] = useState(false);
  const dispatch = useDispatch();

  const selectUserState = (state) => state.user;
  const userProperties = createSelector(selectUserState, (ecom) => ({
    isSuccess: ecom.isSuccess,
    isLoading: ecom.isLoading,
  }));
  const { isLoading, isSuccess } = useSelector(userProperties);

  const formik = useFormik({
    initialValues: {
      image: null,
      name: "",
      email: "",
      experience: "",
      skills: [],
      bio: "",
      referral_code: "",
      password: "",
      confirm_password: "",
    },
    validationSchema: ArtistValidationSchema,
    onSubmit: (values) => {

      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("email", values.email);
      formData.append("user_type", 2);
      formData.append("password", values.password);
      formData.append("password_confirmation", values.confirm_password);
      if (values.image) {
        formData.append("image", values.image);
      }
      formData.append("location_name", null);
      formData.append("location_lat", null);
      formData.append("location_lang", null);
      // formData.append("experince", values.experience);
      formData.append("in_house_artist", 1);
      // formData.append("bio", values.bio);
       formData.append("bio", null);
      // formData.append("skills", JSON.stringify(values.skills));
       formData.append("skills",[]);
      formData.append("referral_code",values.referral_code);

      dispatch(onSignUpUser(formData));
    },
  });

  // Handle Image Upload
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      formik.setFieldValue("image", file);
      setPreview(URL.createObjectURL(file));
    }
  };

  // Reset form when success
  useEffect(() => {
    if (isSuccess) {
      toast.success('Artist created successfully');
      formik.resetForm();
      setPreview(null);
    }
  }, [isSuccess]);

  // Spinner toggle
  useEffect(() => {
    setIsShowSpinner(isLoading);
  }, [isLoading]);

  

  return (
    <>
      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color ">
        <Header title={"Add In House Artist"} showBack={true} />
      </header>

      <div className="w-full  mx-auto">
        <form onSubmit={formik.handleSubmit} className="w-full">
          <div className="w-full mt-5 border border-border_color p-3 sm:py-5 sm:px-[26px] rounded-[14px]">
            
            {/* Profile Image */}
            <div className="w-full flex flex-col xs:flex-row items-center justify-center">
              <div className="w-[128px] h-[128px] border border-secondary rounded-full p-2 flex items-center justify-center">
                <div className="relative w-[117px] h-[117px]">
                  <div className="w-full h-full rounded-full bg-white overflow-hidden flex items-center justify-center">
                    {preview ? (
                      <img
                        src={preview}
                        alt="Profile"
                        className="w-full h-full object-cover object-center"
                      />
                    ) : (
                      <span className="text-gray-500">
                        <CiImageOn className="text-8xl text-gray-300" />
                      </span>
                    )}
                  </div>
                  <input
                    type="file"
                    id="profileUpload"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={handleImageChange}
                    className="hidden"
                  />
                  <label
                    htmlFor="profileUpload"
                    className="absolute bottom-0 right-0 rounded-full cursor-pointer"
                  >
                    <div className="w-[30px] h-[30px]">
                      <img
                        src={editIcon}
                        alt="edit"
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </label>
                </div>
              </div>
              {formik.errors.image && formik.touched.image && (
                <p className="text-red-500 text-sm">{formik.errors.image}</p>
              )}
            </div>

            {/* Name & Email */}
            <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 mb-[10px] mt-10">
              <div className="flex flex-col">
                <label htmlFor="name" className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
                  Name
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Enter your name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                />
                {formik.errors.name && formik.touched.name && (
                  <p className="text-red-500 text-sm">{formik.errors.name}</p>
                )}
              </div>

              <div className="flex flex-col">
                <label htmlFor="email" className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Enter your email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                />
                {formik.errors.email && formik.touched.email && (
                  <p className="text-red-500 text-sm">{formik.errors.email}</p>
                )}
              </div>
            </div>

            {/* Referral & Experience */}
            <div className="w-full grid grid-cols-1  gap-4 mb-[10px]">
              <div className="flex flex-col">
                <label htmlFor="referral_code" className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
                  Referral Code
                </label>
                <input
                  id="referral_code"
                  name="referral_code"
                  type="text"
                  placeholder="Enter your referral code"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.referral_code}
                  className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                />
                {formik.errors.referral_code && formik.touched.referral_code && (
                  <p className="text-red-500 text-sm">{formik.errors.referral_code}</p>
                )}
              </div>

              {/* <div className="flex flex-col">
                <label htmlFor="experience" className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
                  Years of Experience
                </label>
                <input
                  id="experience"
                  name="experience"
                  type="text"
                  placeholder="Enter years of experience"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.experience}
                  className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                />
                {formik.errors.experience && formik.touched.experience && (
                  <p className="text-red-500 text-sm">{formik.errors.experience}</p>
                )}
              </div> */}
            </div>

            {/* Passwords */}
            <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 mb-[10px]">
              <div className="flex flex-col">
                <label htmlFor="password" className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
                  Password
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  placeholder="Enter your password"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.password}
                  className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                />
                {formik.errors.password && formik.touched.password && (
                  <p className="text-red-500 text-sm">{formik.errors.password}</p>
                )}
              </div>
              <div className="flex flex-col">
                <label htmlFor="confirm_password" className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
                  Confirm Password
                </label>
                <input
                  id="confirm_password"
                  name="confirm_password"
                  type="password"
                  placeholder="Confirm your password"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.confirm_password}
                  className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                />
                {formik.errors.confirm_password && formik.touched.confirm_password && (
                  <p className="text-red-500 text-sm">{formik.errors.confirm_password}</p>
                )}
              </div>
            </div>

            {/* Skills */}

            {/* <div className="w-full grid grid-cols-1 gap-4 mb-[10px]">
              <div className="flex flex-col">
                <label className="block text-lable_color font-grotesk text-[16px] font-bold mb-2">
                  Skills
                </label>
                <div className="w-full bg-white border border-border_color rounded-xl p-3 focus-within:ring-1 focus-within:ring-primary focus-within:border-primary">
                  <div className="flex flex-wrap gap-2 mb-2">
                    {formik.values.skills.map((skill, idx) => (
                      <div key={idx} className="flex items-center gap-2 border border-primary text-primary px-3 py-1 rounded-3xl text-sm font-bold">
                        {skill}
                        <button
                          type="button"
                          className="ml-1 text-red-500 hover:text-red-700"
                          onClick={() =>
                            formik.setFieldValue(
                              "skills",
                              formik.values.skills.filter((s) => s !== skill)
                            )
                          }
                        >
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>
                  <textarea
                    rows={4}
                    placeholder="Type a skill and press Enter..."
                    className="w-full resize-none rounded-xl text-[#201D1D] text-[16px] font-medium font-grotesk focus:outline-none"
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && e.target.value.trim() !== "") {
                        e.preventDefault();
                        const newSkill = e.target.value.trim();
                        if (!formik.values.skills.includes(newSkill)) {
                          formik.setFieldValue("skills", [...formik.values.skills, newSkill]);
                        }
                        e.target.value = "";
                      }
                    }}
                  ></textarea>
                </div>
                {formik.errors.skills && formik.touched.skills && (
                  <p className="text-red-500 text-sm">{formik.errors.skills}</p>
                )}
              </div>
            </div> */}

            {/* Bio */}
            {/* <div className="w-full grid grid-cols-1 gap-4 mb-[10px]">
              <div className="flex flex-col">
                <label htmlFor="bio" className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
                  Bio
                </label>
                <textarea
                  id="bio"
                  name="bio"
                  rows={4}
                  placeholder="The additional information provided by the user for the sketch..."
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.bio}
                  className="w-full resize-none p-3 rounded-xl border border-border_color text-[#201D1D] text-[16px] font-medium font-grotesk focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                ></textarea>
                {formik.errors.bio && formik.touched.bio && (
                  <p className="text-red-500 text-sm">{formik.errors.bio}</p>
                )}
              </div>
            </div> */}

            {/* Submit */}
            <div className="w-full flex items-center justify-end mt-4">
              <button type="submit" className="flex items-center bg-primary text-white py-3 px-5 rounded-[10px] gap-1">
                {isShowSpinner ? <Spinner /> : "Create"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}
